import React from "react";

import { Stack, Typography } from "@mui/material";
import { colors } from "@zapalacorp/tokens";
import { Color } from "Components/Form/Button";
import { useTranslation } from "react-i18next";

import Modal, { ModalType } from "../Modal";
import useStyles from "./styles";

interface Props {
  open: boolean;
  modalTitle?: string;
  contentTitle?: string;
  subContentTile?: string;
  saveButtonTitle?: string;
  cancelButtonTitle?: string;
  onClose?: (isConfirmed: boolean) => void;
  onSave: Function;
}

const ConfirmDeleteModal = (props: Props) => {
  const { open, onClose, onSave } = props;

  const { t: translate } = useTranslation();

  const classes = useStyles();

  return (
    <Modal
      open={open}
      className={classes.modal}
      handleClose={() => onClose && onClose(false)}
      title={props?.modalTitle || translate("deleteData")}
      showActionButtons
      type={ModalType.DELETE}
      data-cy="confirmDeleteRecord"
      actionButtonProps={{
        onCancel: () => onClose && onClose(false),
        onSave: () => onSave && onSave(),
        customColorSave: Color.ERROR,
        customColorCancel: Color.TEXT_INFO,
        textSave: props?.saveButtonTitle || translate("confirmDelete"),
        dataCySave: "modalConfirmDeleteButton",
        dataCyCancel: "modalConfirmDeleteCancel",
      }}
    >
      <Stack width="100%" direction="column" spacing={1}>
        <Typography
          fontFamily="Manrope"
          fontWeight={400}
          fontSize="16px"
          lineHeight="24px"
          letterSpacing={"0.5px"}
          color={colors.gray600}
        >
          {props?.contentTitle && translate(props?.contentTitle)}
        </Typography>
        <Typography
          fontFamily="Manrope"
          fontWeight={400}
          fontSize="16px"
          lineHeight="24px"
          letterSpacing={"0.5px"}
          color={colors.error600}
        >
          {props?.subContentTile && translate(props?.subContentTile)}
        </Typography>
      </Stack>
    </Modal>
  );
};

export default ConfirmDeleteModal;
